import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../auth.jsx';
import Field from '../components/Field.jsx';
import JustAttendAd from '../components/JustAttendAd.jsx';
import Alert from '../components/ui/Alert.jsx';
import { PageHeader } from '../components/ui/index.jsx';

const TOPICS = [
  ['help', 'Help using SummitShield'],
  ['scam', 'Reporting a scam or something urgent'],
  ['platform', 'I’m interested in Just Attend’s event platform'],
  ['feedback', 'Feedback or an idea'],
  ['other', 'Something else'],
];

export default function Contact() {
  const { user, organisation } = useAuth();
  const [form, setForm] = useState({ topic: '', message: '', phone: '' });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => { setForm({ ...form, [k]: e.target.value }); setErrors({ ...errors, [k]: undefined }); };

  const submit = async (e) => {
    e.preventDefault();
    const local = {};
    if (!form.topic) local.topic = 'Choose what it’s about.';
    if (form.message.trim().length < 10) local.message = 'Tell us a little more (at least a sentence).';
    if (Object.keys(local).length) { setErrors(local); return; }
    setBusy(true); setError('');
    try {
      await api('/portal/contact', { method: 'POST', body: { ...form, organisation_id: organisation?.id } });
      setSent(true);
    } catch (err) {
      setErrors(err.data?.fields || {});
      setError(err.data?.fields ? '' : err.message);
    }
    setBusy(false);
  };

  return (
    <div className="page">
      <PageHeader title="Contact us" subtitle="SummitShield is looked after by the team at Just Attend. Send us a message and a real person will reply, usually the same working day." />
      <div className="help-index-layout">
        <div className="help-index-main">
          {sent ? (
            <section className="card" aria-live="polite">
              <h2>Thanks, we’ve got your message</h2>
              <p>We’ll reply to <strong>{user.email}</strong>. If it’s about a scam that’s happening right now, it also helps to add it to your <Link to="/inbox/add">Messages</Link> so we can catch it straight away.</p>
              <button type="button" className="btn btn-secondary" onClick={() => { setSent(false); setForm({ topic: '', message: '', phone: '' }); }}>Send another message</button>
            </section>
          ) : (
            <form className="card contact-form" onSubmit={submit} noValidate>
              {error && <Alert tone="danger">{error}</Alert>}
              <p className="muted">We’ll reply to <strong>{user.email}</strong>{organisation ? <> about <strong>{organisation.name}</strong></> : ''}.</p>
              <Field as="select" label="What’s it about?" value={form.topic} onChange={set('topic')} error={errors.topic}>
                <option value="">Choose one</option>
                {TOPICS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </Field>
              <Field as="textarea" label="Your message" rows={8} value={form.message} onChange={set('message')} error={errors.message} maxLength={5000} counter
                hint="If it’s about a particular email or website, tell us which one (the subject, or the web address)." />
              <Field label="Phone number" optional value={form.phone} onChange={set('phone')} error={errors.phone} inputMode="tel" autoComplete="tel"
                hint="Only if you’d like us to call you back." />
              <div className="actions">
                <button type="submit" className="btn btn-primary" disabled={busy}>{busy ? 'Sending…' : 'Send message'}</button>
              </div>
            </form>
          )}
          <p className="muted small">We use what you send only to answer you. See our <Link to="/privacy">privacy policy</Link>.</p>
        </div>
        <aside className="help-index-side">
          <section className="card">
            <h2>Looking for an answer now?</h2>
            <p>Every page has a guide in the help centre, with examples.</p>
            <Link to="/help" className="btn btn-secondary">Open the help centre</Link>
          </section>
          <JustAttendAd />
        </aside>
      </div>
    </div>
  );
}
